/* eslint-disable import/no-unresolved */
import { useQuery } from "react-query";
import { useState } from "react";
import useReactRouterDomQuery from "src/utils/hooks/useQuery";
import Payment from "src/components/Payment";
import { verifyPaymentLink } from "src/services/VerifyCustomer";
import CustomLoader from "src/shared/CustomLoader";
import Header from "src/shared/Header";
import StorageService from "src/utils/Storage/storageService";
import store from "src/redux/store";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";

function PaymentPage() {
  // const params = useParams();
  const query = useReactRouterDomQuery();
  const id = query.get("id") as string;
  const [isCancelled, setIsCancelled] = useState(false);

  const {
    isLoading,
    isError,
    data: paymentData
  } = useQuery(["verifyPayment"], () => verifyPaymentLink(id || ""), {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!id,
    onSuccess: (res: any) => {
      StorageService.setInLocalStorage("paymentToken", res?.data?.token);
    },
    onError: () => {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          message: "Payment Failed!"
        })
      );
    }
  });

  if (isLoading) {
    return <CustomLoader />;
  }

  if (isError) {
    return <div className="text-center mt-20 text-2xl font-bold text-hotShot">No Data Found</div>;
  }

  return (
    <div>
      <Header isEnable={false} />
      {isCancelled ? (
        <div className="w-90/100 md:w-41/100 flex justify-between items-center rounded-3xl mx-auto h-40 shadow-paymentShadow mt-34.75 px-2 md:px-10 mb-34.25">
          <p className="text-center text-2xl font-bold text-hotShot">
            Your transaction has been cancelled
          </p>
        </div>
      ) : (
        <Payment
          setIsCancelled={setIsCancelled}
          leadId={id}
          data={paymentData?.data || {}}
          isButtonEnable
        />
      )}

      {/* <div className="w-90/100 md:w-41/100 flex justify-between items-center rounded-3xl mx-auto h-40 shadow-paymentShadow mt-34.75 px-15.5 mb-34.25">
        <Button variant="outlined" className="!text-black !uppercase h-12.5 w-472/1000 rounded-lg">
          Cancel
        </Button>
        <Button
          onClick={() => window.location.reload()}
          variant="contained"
          className="!uppercase h-12.5 w-472/1000 rounded-lg">
          Refresh
        </Button>
      </div> */}
    </div>
  );
}

export default PaymentPage;
